import type { ChangeEvent } from "react";

import { cx, styled } from "simplydo/react/styled";

import { FOCUS_RING } from "../utils/focus";
import type { TextAreaProps } from "./TextArea.types";

const StyledTextArea = styled.textarea`
  margin: 0;
  -webkit-appearance: none;
  tap-highlight-color: rgba(255, 255, 255, 0);
  padding: 0.78571429em 1em;
  background: #ffffff;
  border: 1px solid rgba(34, 36, 38, 0.15);
  outline: none;
  color: rgba(0, 0, 0, 0.87);
  border-radius: 0.28571429rem;
  box-shadow: 0 0 0 0 transparent inset;
  transition:
    color 0.1s ease,
    border-color 0.1s ease;
  font-family: inherit;
  font-size: 1em;
  line-height: 1.2857;
  resize: vertical;
  width: 100%;
  box-sizing: border-box;

  &:focus {
    background: #ffffff;
    color: rgba(0, 0, 0, 0.95);
  }

  &:focus-visible {
    ${FOCUS_RING}
  }

  &::placeholder {
    color: rgba(191, 191, 191, 0.87);
  }

  &:disabled {
    opacity: 0.45;
  }
`;
const TextAreaComponent = (props: TextAreaProps) => {
  const {
    rows = 3,
    value,
    defaultValue,
    onChange,
    placeholder,
    disabled,
    name,
    className,
    style,
    id,
    autoFocus,
    readOnly,
    ...rest
  } = props;
  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    onChange?.(e, { value: e.target.value, name: name ?? e.target.name });
  };

  return (
    <StyledTextArea
      className={cx(className)}
      style={style}
      rows={rows}
      value={value}
      defaultValue={defaultValue}
      onChange={handleChange}
      placeholder={placeholder}
      disabled={disabled}
      name={name}
      id={id}
      autoFocus={autoFocus}
      readOnly={readOnly}
      {...rest}
    />
  );
};

export const TextArea = styled(TextAreaComponent)``;
